import OrderDetails from '../components/OrderDetails';
import OrderDetailsProvider from './OrderDetailsContext';

const OrderDetailsPage = () => {
  return (
    <OrderDetailsProvider>
      <OrderDetails />
    </OrderDetailsProvider>
  );
};

export default OrderDetailsPage;
